import React, { useEffect, useState } from 'react';
import * as CounterStyle from "./countdown.module.scss"

const CountdownComponent = () => {
  const [daysCounter, setDaysCounter] = useState(0)
  const [hoursCounter, setHoursCounter] = useState(0)
  const [minutesCounter, setMinutesCounter] = useState(0)
  const [secondsCounter, setSecondsCounter] = useState(0)

  useEffect(() => {
    function initializeClock() {
      const initialDate = new Date("Mar 24, 2025 00:00:00").getTime();
      const repeatInterval = 4 * 24 * 60 * 60 * 1000; // 4 days

      const calculateEndTime = (now) => {
        if (now < initialDate) {
          return initialDate;
        }

        const elapsedTime = now - initialDate;
        const cycles = Math.floor(elapsedTime / repeatInterval);
        return initialDate + ((cycles + 1) * repeatInterval);
      }

      const now = new Date().getTime();
      let endTime = calculateEndTime(now);

      const updateClock = () => {
        const currentTime = new Date().getTime();
        const total = endTime - currentTime;

        if (total <= 0) {
          endTime = calculateEndTime(currentTime);
        }

        setDaysCounter(Math.floor(total / (1000 * 60 * 60 * 24)));
        setHoursCounter(Math.floor((total % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        setMinutesCounter(Math.floor((total % (1000 * 60 * 60)) / (1000 * 60)));
        setSecondsCounter(Math.floor((total % (1000 * 60)) / 1000));
      };

      updateClock();
      const intervalId = setInterval(updateClock, 1000);

      return () => clearInterval(intervalId);
    }

    initializeClock();
  }, []);

  return (
    <div className={CounterStyle.countdownWrapper}>
      <span className={CounterStyle.countdownWrapper__timeSegment}>
        {daysCounter}
      </span>
      :
      <span className={CounterStyle.countdownWrapper__timeSegment}>
        {hoursCounter}
      </span>
      :
      <span className={CounterStyle.countdownWrapper__timeSegment}>
        {minutesCounter}
      </span>
      :
      <span className={CounterStyle.countdownWrapper__timeSegment}>
        {secondsCounter}
      </span>
    </div>
  )
}

export default CountdownComponent